import clsx from 'clsx';

type LegendProps = React.ComponentPropsWithoutRef<'table'> & {
  children: React.ReactNode;
};
export function PieChartLegend({
  children,
  className,
  ...props
}: LegendProps): React.JSX.Element {
  return (
    <table
      {...props}
      className={clsx(
        'border-separate border-spacing-x-3 border-spacing-y-1',
        className
      )}
    >
      <thead className="text-xs/5 text-slate11">
        <tr>
          <td colSpan={4} className="border-b border-slate6 pb-1">
            Legend
          </td>
        </tr>
      </thead>

      <tbody>{children}</tbody>
    </table>
  );
}

type PieChartLegendRowProps = React.ComponentPropsWithoutRef<'tr'> & {
  children: React.ReactNode;
};
export function PieChartLegendRow({
  children,
  className,
  ...props
}: PieChartLegendRowProps): React.JSX.Element {
  return (
    <tr
      {...props}
      className={clsx('text-right text-sm/6 text-slate11', className)}
    >
      {children}
    </tr>
  );
}

type PieChartLegendIdxProps = React.ComponentPropsWithoutRef<'td'> & {
  idx: number;
};
export function PieChartLegendIdx({
  idx,
  className,
  ...props
}: PieChartLegendIdxProps): React.JSX.Element {
  return (
    <td {...props} className={clsx('text-xs/5', className)}>
      #{idx + 1}
    </td>
  );
}

type PieChartLegendMainProps = React.ComponentPropsWithoutRef<'td'> & {
  children: React.ReactNode;
};
export function PieChartLegendMain({
  children,
  className,
  ...props
}: PieChartLegendMainProps): React.JSX.Element {
  return (
    <td
      {...props}
      className={clsx('text-left font-semibold text-slate12', className)}
    >
      {children}
    </td>
  );
}

type PieChartLegendCellProps = React.ComponentPropsWithoutRef<'td'> & {
  children: React.ReactNode;
};
export function PieChartLegendCell({
  children,
  className,
  ...props
}: PieChartLegendCellProps): React.JSX.Element {
  return (
    <td {...props} className={clsx(className)}>
      {children}
    </td>
  );
}
